import React, { useContext } from 'react'
import { openExternalHttp } from '@App/navigation/safe-navigation'
import { StoresContext } from '@App/contexts'

interface DownloadLinkProps {
    fetchLink: () => Promise<string>
    text?: string
}

const DownloadLink = ({ fetchLink, text }: DownloadLinkProps) => {
    const { preloaderStore } = useContext(StoresContext)

    const fetchAndRedirect = async () => {
        preloaderStore.openTransparentPreloader(true)
        try {
            const url = await fetchLink()
            openExternalHttp(url)
        } finally {
            preloaderStore.openTransparentPreloader(false)
        }
    }

    return (
        <a role="link" className="small" onClick={fetchAndRedirect} rel="noopener noreferrer">
            {text || 'Download'}
        </a>
    )
}

export default DownloadLink
